// ProfileNotFound.tsx — Rendered when a profile handle cannot be resolved.

import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { ConsolePanel } from '@/ui';

// ─── Styled ───────────────────────────────────────────────────────────────────

const Card = styled(ConsolePanel)`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 32px 24px;
  text-align: center;
`;

const Heading = styled.h2`
  margin: 0;
  font-family: ${({ theme }) => theme.font.display};
  font-size: ${({ theme }) => theme.fontSize.lg};
  font-weight: 700;
  color: ${({ theme }) => theme.color.textPrimary};
`;

const Body = styled.p`
  margin: 0;
  font-family: ${({ theme }) => theme.font.body};
  font-size: ${({ theme }) => theme.fontSize.sm};
  color: ${({ theme }) => theme.color.textMuted};
  line-height: 1.55;
`;

const HomeLink = styled(Link)`
  font-family: ${({ theme }) => theme.font.body};
  font-size: ${({ theme }) => theme.fontSize.sm};
  color: ${({ theme }) => theme.color.brandFrom};
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.color.focusRing};
    outline-offset: 2px;
  }
`;

// ─── Component ────────────────────────────────────────────────────────────────

export function ProfileNotFound() {
  return (
    <Card role="alert">
      <Heading>User not found</Heading>
      <Body>This profile doesn&rsquo;t exist or the handle is wrong.</Body>
      <HomeLink to="/">Back to home</HomeLink>
    </Card>
  );
}
